import React from 'react'

import styles from './TableHeader.css'
import { SORT_TYPES } from '../../../../constants'
import { FormattedMessage } from 'react-intl'

const TableHeader = props => {
  const {
    enableSort = true,
    label,
    filterActive,
    columnHeader,
    handleOnFilterButtonClick,
    handleOnSortClick,
    lastElement,
    sortBy,
    sortDirection,
    selectedPopover,
    Popover,
    noFilterPlaceholder = false,
    disable = false,
  } = props

  const cn = !lastElement ? styles.columnFilter : styles.lastColumnFilter
  const activeCn = !filterActive ? styles.filterButton : styles.filterButtonActive

  let sortDirectionIcon = <div className={styles.sortDirectionNone} />

  if (enableSort && sortBy === columnHeader) {
    switch (sortDirection) {
    case SORT_TYPES.DESC:
      sortDirectionIcon = (
        <div className={styles.sortDirectionDesc} />
      )
      break
    case SORT_TYPES.ASC:
      sortDirectionIcon = (
        <div className={styles.sortDirectionAsc} />
      )
      break
    case null:
    default:
      break
    }
  }

  return (
    <div className={styles.headerWithControls}>
      {enableSort && (
        <div
          className={styles.columnHeader}
          onClick={() => handleOnSortClick(columnHeader)}
        >
          {label}
          {sortDirectionIcon}
        </div>
      )}
      {!enableSort && (
        <div
          className={styles.columnHeaderNoSort}
        >
          {label}
        </div>
      )}

      {Popover && (
        <div className={disable ? `${styles.visibilityHide} ${cn}` : `${cn}`}>
          <button
            className={activeCn}
            onClick={() => handleOnFilterButtonClick(columnHeader)}
            data-action="filter"
            data-label={columnHeader}
            disabled={disable}
          >
            <FormattedMessage id="label.filter" />
          </button>
          {selectedPopover === columnHeader &&
          <div className={styles.popoverWrapper}>
            {Popover}
          </div>
          }
        </div>
      )}
      {noFilterPlaceholder && (
        <div className={styles.columnFilter} />
      )}
    </div>
  )
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/components/TableHeader/TableHeader.jsx